import React from 'react'

const InstitucionalMision = () => {
    return (
        <div className='container-fluid fondotransparente4' >
            <br />
            <div className='btn-titulo'>
                <div className='botonbordeazul'>
                    <h1 className='text-white px-5 mx-5 py-3 h1'>Misión, Visión, Objetivos</h1>
                </div>
            </div>
            <br />
            <div className='contcaja'>
                <div className='cajagrisclaro'>
                    <h2 className='titulocaja'>InProJuy</h2>
                </div>
                <div className='cuerpo'>
                    <p className=''>El Ente Regulador de Juego de Azar de la Provincia de Jujuy, es una entidad autárquica de la Administración Publica del Gobierno de la Provincia, creada por Ley 6.234 que está investido de las potestades necesarias y suficientes para atender a la regulación del juego de azar en todas sus formas.</p>
                </div>
            </div>
            <br />
            <div className='contcaja'>
                <div className='cajaroja'>
                    <h2 className='titulocaja'>Misión</h2>
                </div>
                <div className='cuerpo'>
                <p className=''>La Misión del Ente, es la de regular y controlar el desarrollo, explotación y comercialización de los juegos de azar, ejerciendo el poder de policía y protegiendo las relaciones debidas entre los licenciatarios y el apostador. Explotar per se o a través de terceros, controlar, fiscalizar y ejercer las acciones necesarias para garantizar la protección del orden público, lucha contra el fraude, prevenir conductas adictivas, proteger derechos de los menores y velar por el desarrollo del juego responsable.</p>
                </div>
            </div>
            <br />
            <div className='contcaja'>
                <div className='cajazul'>
                    <h2 className='titulocaja'>Visión</h2>
                </div>
                <div className='cuerpo'>
                <p className=''>Tenemos la Visión de ser, un organismo funcionalmente integrado, de carácter técnico y especializado, que procura cumplir de manera eficiente sus objetivos, a través de la regulación, intervención y fiscalización en el desarrollo de los juegos de azar, velando por la transparencia de los mismos. Mantener el equilibrio entre los intereses de los apostadores y de las licenciatarios, adaptando e implementando herramientas y nuevas tecnologías para realizar el control del juego en sus distintas modalidades, entendiendo el juego como actividad recreativa y responsable.</p>
                </div>
            </div>
            <br />
            <div className='contcaja'>
                <div className='cajagris'>
                    <h2 className='titulocaja '>Objetivos Principales</h2>
                </div>
                <div className='cuerpo'>
                <p className=''>El Ente regulador tiene a su cargo la explotación, el control y la fiscalización de los juegos de azar en los términos fijados por la Ley 6.234. A tal fin, sus principales objetivos son los siguientes:
                    <ul>
                        <li>Asegurar la protección adecuada de los intereses de los apostadores.</li>
                        <li>Prevenir el lavado de activos en la actividad regulada</li>
                        <li>Regular el desarrollo, explotación y comercialización de los juegos de azar existentes en el ámbito de la jurisdicción provincial y de aquellos que en el futuro fueren creados.</li>
                        <li>Autorizar o denegar, la creación e implementación de las modalidades de juegos de azar en la jurisdicción provincial como así también aprobar los reglamentos respectivos.</li>
                        <li>Proteger y asegurar la razonabilidad y proporcionalidad de las contraprestaciones debidas entre las Licenciatarias o entidades autorizadas y el apostador.</li>
                        <li> Ejercer el poder de policía en todo lo referente a la administración y desarrollo de los juegos de azar, en procura del estricto cumplimiento de las normas legales, dictando los reglamentos que fueran menester para el cumplimiento de su cometido y aplicando las sanciones que pudieren corresponder.</li>
                        <li>Erradicar el juego ilegal.</li>
                        <li>Promover el juego responsable</li>
                        <br />
                    </ul></p>
                </div>
            </div>
        </div>
    )
}

export default InstitucionalMision